import { useMutation, useQueryClient } from "@tanstack/react-query";

import { unenrollmentRequest } from "@/apiQueries/multisigUnenrollment/multisigUnenrollmentRequest";
import {
  MULTISIG_UNENROLLMENT_QUERY_KEY,
  MULTISIG_UNENROLLMENT_URL,
} from "@/apiQueries/multisigUnenrollment/useMultisigUnenrollment";

import type { UnenrollmentError } from "@/helpers/unenrollmentErrors";

import type { MultisigUnenrollmentInitiateResponse } from "@/types";

export const useMultisigUnenrollmentInitiate = () => {
  const queryClient = useQueryClient();

  return useMutation<MultisigUnenrollmentInitiateResponse, UnenrollmentError, void>({
    mutationFn: () =>
      unenrollmentRequest<MultisigUnenrollmentInitiateResponse>(MULTISIG_UNENROLLMENT_URL, {
        method: "POST",
        body: JSON.stringify({}),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MULTISIG_UNENROLLMENT_QUERY_KEY }),
  });
};
